import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./Theme/theme";
import axios from "axios";
const Loading = lazy(() => import("./Components/Loading/Loading"));

// Remove any CORS headers that might be added to requests
axios.interceptors.request.use(
  (config) => {
    delete config.headers["Access-Control-Allow-Origin"];
    delete config.headers["Access-Control-Allow-Methods"];
    delete config.headers["Access-Control-Allow-Headers"];
    delete config.headers["Access-Control-Allow-Credentials"];
    delete config.headers["access-control-allow-origin"];
    delete config.headers["access-control-allow-methods"];
    delete config.headers["access-control-allow-headers"];
    delete config.headers["access-control-allow-credentials"];
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <ThemeProvider theme={theme}>
    <Suspense fallback={<Loading />}>
      <BrowserRouter>
      <App />
      </BrowserRouter>
    </Suspense>
  </ThemeProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
